import React from "react";
import classNames from "classnames";
import { Identifiable, Resource } from "@planzone/dto";
import { SelectList } from "@common/selectList";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { ResourceAvatar } from "@common/resourceAvatar";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { useScreenWatcher } from "@common/screenWatcher";
import { Props } from "./types";
import styles from "./styles.scss";

function ParticipantsPicker({ resources, label, onAdd, onRemove }: Props) {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [openUpward, setOpenUpward] = React.useState(false);
  const screen = useScreenWatcher();

  const listRefCallback = React.useCallback(
    (node: HTMLDivElement | null) => {
      if (!node || !containerRef.current) {
        setOpenUpward(false);
        return;
      }
      const containerRect = containerRef.current.getBoundingClientRect();
      setOpenUpward(containerRect.bottom + node.scrollHeight > screen.height);
    },
    [screen.height],
  );

  return (
    <div className={styles.field}>
      <label className={styles.label}>{label}</label>
      <div className={styles.participants} ref={containerRef}>
        {resources.map((r) => (
          <div
            key={r.uuid}
            className={styles.participantAvatar}
            onClick={() => onRemove(r)}
          >
            <ResourceAvatar resource={r} />
          </div>
        ))}
        <SelectList
          rootClassName={styles.addParticipantRoot}
          inputClassName={styles.addParticipantRoot}
          listClassName={classNames(styles.participantsMenu, {
            [styles.participantsMenuUpward]: openUpward,
          })}
          multiple
        >
          {() => ({
            input: <AddAllocationIcon className={styles.addParticipantIcon} />,
            list: (
              <div ref={listRefCallback}>
                <ResourceAllocationMenu
                  allocatedResources={resources}
                  select={(selected: Identifiable<Resource>[]) =>
                    onAdd(selected)
                  }
                  unSelect={(unselected: Identifiable<Resource>[]) =>
                    unselected.forEach((r) => onRemove(r))
                  }
                  openedViews={["resources"]}
                />
              </div>
            ),
          })}
        </SelectList>
      </div>
    </div>
  );
}

export { ParticipantsPicker };
